import CommonSkeleton from '@/components/common/Skeleton';
const Skeleton = () => {
  return (
    <div className="flex mx-3 my-10">
      <CommonSkeleton.Image className="!w-36 !h-36 mr-2 rounded-500" />
      <div className="flex-1 h-36 flex flex-col justify-between">
        <div>
          <div className="h-6 bg-surface-100-hairline w-full skeleton "></div>
          <div className="h-6 mt-1 bg-surface-100-hairline w-36 skeleton "></div>
        </div>
        <div className="w-16 skeleton h-6"></div>
      </div>
    </div>
  );
};

export default Skeleton;
